import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["show", "content"];

  static values = {
    startShown: Boolean,
    paramName: String,
  };

  connect() {
    // Use startShown value (which reads from URL params in the view)
    if (this.startShownValue) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    $(this.showTargets).addClass("hidden");
    $(this.contentTargets).removeClass("hidden");
    this.updateUrl(true);
  }

  hide() {
    $(this.showTargets).removeClass("hidden");
    $(this.contentTargets).addClass("hidden");
    this.updateUrl(false);
  }

  updateUrl(isShown) {
    // Update URL to reflect current state using namespaced parameter
    const url = new URL(window.location);
    const paramName = this.hasParamNameValue ? this.paramNameValue : "show_expired";

    if (isShown) {
      url.searchParams.set(paramName, "true");
    } else {
      url.searchParams.delete(paramName);
    }

    // Update URL without page reload
    window.history.replaceState({}, "", url.toString());
  }
}
